"use client";

import { useState } from "react";
import { ArrowUp } from "lucide-react";
import { BlockProps } from "../BlocksManager/registry";

function getItemColors(index: number) {
  const isEven = index % 2 === 0;

  return {
    bg: isEven ? "bg-green-light" : "bg-orange-light",
    iconBg: isEven ? "bg-green" : "bg-orange",
  };
}

function truncateQuestion(text: string, maxLength = 28) {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + "...";
}

export default function QuestionsFrequentes({ data }: BlockProps) {
  if (!data) return null;

  const items = data.faq || [];
  const [openIndex, setOpenIndex] = useState(-1);

  const toggleItem = (index: number) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <section className="bg-white py-12 lg:py-20" key={data.id}>
      <div className="container">
        <h2 className="text-center font-literata text-[32px] font-bold leading-tight text-black lg:text-[60px]">
          {data.titre}
        </h2>

        <div className="mt-8 flex flex-col gap-4 lg:gap-5">
          {items.map((item: any, index: number) => {
            const isOpen = openIndex === index;
            const colors = getItemColors(index);

            return (
              <article
                key={item.id}
                className={`overflow-hidden rounded-[20px] lg:rounded-[28px] ${colors.bg} transition-all duration-300`}
              >
                <button
                  type="button"
                  onClick={() => toggleItem(index)}
                  className="flex w-full items-start justify-between gap-3 px-5 py-4 text-left lg:px-10 lg:py-6"
                >
                  <span className="font-body font-bold leading-[1.2] text-black text-[18px] lg:text-[32px]">
                    {/* Mobile */}
                    <span className="block lg:hidden">
                      {isOpen
                        ? item.label
                        : truncateQuestion(item.label, 28)}
                    </span>

                    {/* Desktop */}
                    <span className="hidden lg:block">{item.label}</span>
                  </span>

                  <span
                    className={`flex h-[48px] w-[48px] shrink-0 items-center justify-center rounded-full lg:h-[85px] lg:w-[64px] lg:rounded-[80px] ${colors.iconBg}`}
                  >
                    <ArrowUp
                      className={`h-5 w-5 text-black transition-transform duration-300 lg:h-8 lg:w-8 ${
                        isOpen ? "rotate-0" : "rotate-180"
                      }`}
                    />
                  </span>
                </button>

                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-5 pb-5 lg:px-10 lg:pb-8">
                      <p className="text-[15px] whitespace-pre-line leading-[1.5] text-black lg:text-[22px]">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}